import { 
    RESET_CHOICES,
    ADD_CHOICE
} from '../actions/constants/ActionTypes';

const initialState = {};

/*
 * Reducer to represent the slotChoices data 
 *
 */
const slotChoices = (state = initialState, action) => {
    switch(action.type) {
        case RESET_CHOICES:
            return initialState;
        case ADD_CHOICE: 
            return {
                ...state,
                ...action.choice // key-value pair of slotId and slotOption (like { 'slot-1-01': 'MA' })
            };
            // return [
            //     ...state,
            //     {
            //         slot: action.slotId,
            //         choice: action.choice
            //     }
            // ]
        default:
            return state;
    }
};

export default slotChoices;